import { h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import CartProductItem from "./CartProductItem";
function CartProducts(props) {
    const { items, mode = { type: "readonly" }, isImageVisible = false, imageType = "square", } = props;
    const isEmpty = items.length === 0;
    return (h("div", { class: "cart-items", "data-field-id": "Cart.products" },
        h("ul", { class: "list-unstyled" },
            isEmpty && h(CartEmpty, null),
            items.map((item) => (h(CartProductItem, { item: item, mode: mode, isImageVisible: isImageVisible, imageType: imageType, key: item.id.value }))))));
}
function CartEmpty() {
    return (h("div", { class: "empty" },
        h("i", { class: "empty__icon icon-shopping-cart", "aria-hidden": "true" }),
        h("p", { class: "empty__text" }, translate(t.restaurants.widgets.cart.empty))));
}
export default observer(CartProducts);
